import {AxiosResponse} from "axios";
import PaymentApi from "../Base/payment-api";
import {DynamicObject} from "../../models/General";

export default (config?: DynamicObject): Promise<AxiosResponse> => {
    const request = PaymentApi.getInstance().request

    let queryParams = '';
    if (config?.cartId) {
        queryParams += queryParams ? `&cartId=${config.cartId}` : `?cartId=${config.cartId}`;
    }

    if (config?.paymentSecret) {
        queryParams += queryParams ? `&paymentSecret=${config.paymentSecret}` : `?paymentSecret=${config.paymentSecret}`;
    }

    if (config?.modelId) {
        queryParams += queryParams ? `&modelId=${config.modelId}` : `?modelId=${config.modelId}`;
    }

    if (config?.referrerUrl) {
        queryParams += queryParams ? `&referrerUrl=${config.referrerUrl}` : `?referrerUrl=${config.referrerUrl}`;
    }

    return request.post(`${process.env.REACT_APP_PAYMENT_API_URL}/${process.env.REACT_APP_VERSION}/checkout/payment-flow/select${queryParams}`,config.data)
}
